/**
 * TypeScript twin of the backend `ProductionFolderPlanningFilterKeys` constants
 * (Digiwall.GoliathDocuments.Planning, Domain.Shared). These strings are the FE↔BE contract — a wrong
 * key silently no-ops (the backend applier ignores unknown keys), so keep both sides in sync.
 */
export const ProductionFolderPlanningFilterKeys = {
  dayBook: 'DayBook',
  customer: 'Customer',
  manufacturer: 'Manufacturer',
  description: 'Description',
  displayNumber: 'DisplayNumber',
} as const;

export type ProductionFolderPlanningFilterKey =
  (typeof ProductionFolderPlanningFilterKeys)[keyof typeof ProductionFolderPlanningFilterKeys];

/** Dropdown (multi-select) filters — the only ones allowed to carry preset values. */
export const PRODUCTION_FOLDER_DROPDOWN_KEYS: ProductionFolderPlanningFilterKey[] = [
  ProductionFolderPlanningFilterKeys.dayBook,
  ProductionFolderPlanningFilterKeys.customer,
  ProductionFolderPlanningFilterKeys.manufacturer,
];

/** Free-text filters — client-side substring only, never carry preset values. */
export const PRODUCTION_FOLDER_TEXT_KEYS: ProductionFolderPlanningFilterKey[] = [
  ProductionFolderPlanningFilterKeys.description,
  ProductionFolderPlanningFilterKeys.displayNumber,
];
